export const detectAutoSalaryIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /* ----------------------------------
     * DELETE auto salary
     * ---------------------------------- */
    const deleteRegex =
        /(delete|remove|erase|drop|get rid of)\s+(the\s+)?(auto salary)?\s*(named|called|for)?\s*(.+)?/;

    const deleteMatch = cleaned.match(deleteRegex);

    if (
        deleteMatch &&
        cleaned.includes("auto") &&
        cleaned.includes("salary")
    ) {
        return {
            intent: "delete_auto_salary",
            name: deleteMatch[5]?.trim() || undefined
        };
    }

    /* ----------------------------------
     * CREATE auto salary
     * ---------------------------------- */
    const createRegex =
        /(create|add|make|setup|set up|configure|define)\s+(a\s+|new\s+)?(auto salary)?\s*(named|called|for)?\s*(.+)?/;

    const createMatch = cleaned.match(createRegex);

    if (
        createMatch &&
        cleaned.includes("auto") &&
        cleaned.includes("salary")
    ) {
        return {
            intent: "create_auto_salary",
            name: createMatch[5]?.trim() || undefined
        };
    }

    return null;
};
